import { Link } from "react-router-dom";

export function TiplyMeMark({ className = "h-9 w-9" }) {
  return (
    <img src="/logo-icon.png" alt="TiplyMe" className={`${className} rounded-[22%] object-cover`} />
  );
}

export function WalletMark({ className = "h-9 w-9" }) {
  return (
    <img src="/logo-icon.png" alt="TiplyMe wallet" className={`${className} rounded-[22%] object-cover`} />
  );
}

export function TiplymeLogo({ className = "", dark = false }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <TiplyMeMark className="h-9 w-9 shadow-lg shadow-brand-navy/20 rounded-[11px]" />
      <span className={`font-heading text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-foreground"}`}>
        Tiply<span className="text-brand-cyan">Me</span>
      </span>
    </Link>
  );
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function googleLogin() {
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleButton({ label = "Continue with Google" }) {
  return (
    <button
      type="button"
      onClick={googleLogin}
      data-testid="google-login-button"
      className="flex w-full items-center justify-center gap-3 rounded-full border border-border bg-white px-5 py-3 text-sm font-semibold text-slate-700 shadow-sm transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-slate-50"
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1Z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z"/></svg>
      {label}
    </button>
  );
}
